import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Panel, EmptyState } from "@/components/admin/shared";
import { waLink, waReminder } from "@/lib/constants";
import { MessageCircle, CheckCheck, BellRing } from "lucide-react";

export const TomorrowReminders = ({ className = "" }) => {
  const [items, setItems] = useState([]);
  const load = async () => setItems((await api.get("/reminders/tomorrow")).data);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const send = (f) => { api.post(`/followups/${f.followup_id}/reminded`).then(load); };
  const sent = items.filter((i) => i.reminded_at).length;

  return (
    <Panel className={className} title={<span className="flex items-center gap-2"><BellRing size={16} className="text-[#D95D1E]" /> Tomorrow's Meetings & Visits</span>}
      action={<span className="text-xs font-bold text-slate-500" data-testid="reminders-count">{sent}/{items.length} reminded</span>}>
      {items.length === 0 ? <EmptyState text="No meetings or visits booked for tomorrow" /> : (
        <div className="space-y-2 max-h-[320px] overflow-y-auto" data-testid="reminders-list">
          {items.map((f) => (
            <div key={f.followup_id} data-testid="reminder-row" className="flex items-center gap-3 p-3 rounded-xl bg-slate-50">
              <div className="font-mono-num text-xs font-bold text-[#081226] w-16">{f.time_label}</div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#081226] truncate">{f.name}</p>
                <p className="text-xs text-slate-400 truncate">{f.type} · {f.mobile}</p>
              </div>
              {f.reminded_at && <span className="text-[10px] font-bold text-emerald-600 flex items-center gap-1" data-testid="reminder-sent-tag"><CheckCheck size={13} /> Sent</span>}
              <a href={waLink(f.mobile, waReminder(f.name, f.type, f.date_label, f.time_label))} target="_blank" rel="noreferrer" onClick={() => send(f)}
                data-testid="reminder-whatsapp-btn" className="h-9 px-3 rounded-lg bg-[#25D366] text-white text-xs font-bold flex items-center gap-1.5 shrink-0">
                <MessageCircle size={15} /> {f.reminded_at ? "Resend" : "Remind"}
              </a>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
